import {
  Control,
  FieldErrors,
  UseFormRegister,
} from '@ltvco/refresh-lib/vendors';
import React from 'react';

import { SearchInput } from '../SearchInput';

import { EmailFormData } from './EmailSearch';

interface EmailInputProps {
  register: UseFormRegister<EmailFormData>;
  placeholder: string;
  errors: FieldErrors<EmailFormData>;
  // eslint-disable-next-line no-unused-vars
  clearErrors: (field?: string) => void;
  onClear: () => void;
  value: string;
  control: Control<EmailFormData>;
}

export const EmailInput = React.memo(
  ({
    register,
    placeholder,
    errors,
    clearErrors,
    onClear,
    value,
    control,
  }: EmailInputProps) => {
    const registerReturn = register('email');

    return (
      <SearchInput
        registerReturn={registerReturn}
        label="Email"
        placeholder={placeholder}
        error={errors.email}
        clearErrors={clearErrors}
        onClear={onClear}
        value={value}
        control={control as unknown as Control}
        fieldName="email"
        autoFocus
      />
    );
  }
);
